import { initialize } from 'redux-form';
import { getProps } from '../props';
import { FORM_NAME } from '../Form';

export default () => async (dispatch) => {
  const { project } = getProps();

  dispatch(initialize(FORM_NAME, { jobsheet_notes: project.jobsheet_notes }))

}
